module.exports = __webpack_public_path__ + "static/media/chensafe23.01d5d768.gif";